import { Info } from "lucide-react";
import CustomTooltip from "../Tooltip/CustomTooltip";

const FormInfo = ({ content, side = "top" }) => (
  <CustomTooltip content={content} side={side}>
    <button type="button" className="cursor-help text-ink-gray-400 hover:text-ink-gray-500" aria-label={content}>
      <Info className="h-3.5 w-3.5" />
    </button>
  </CustomTooltip>
);

export default FormInfo;